import { useEffect, useRef, useState } from 'react';

const MAX_FIREFLIES = 15;

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

export default function Background() {
  const [fireflies, setFireflies] = useState([]);
  const fireflyId = useRef(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setFireflies((flies) => {
        if (flies.length < MAX_FIREFLIES) {
          return [
            ...flies,
            {
              id: fireflyId.current++,
              left: getRandom(0, 100),
              top: getRandom(0, 100),
              moveDelay: getRandom(0, 20),
              driftDelay: getRandom(0, 8),
              flashDelay: getRandom(0, 12),
            },
          ];
        }

        return flies;
      });
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (fireflies.length === 0) return;

    const timeout = setTimeout(() => {
      setFireflies((flies) => flies.slice(1));
    }, 2000);

    return () => clearTimeout(timeout);
  }, [fireflies]);

  return (
    <>
      <div className="stars"></div>
      <div className="lines">
        {[...Array(10)].map((_, i) => (
          <div className="line" key={i}></div>
        ))}
      </div>
      {fireflies.map((firefly) => (
        <div
          className="firefly"
          key={firefly.id}
          style={{
            left: `${firefly.left}%`,
            top: `${firefly.top}%`,
            '--move-delay': `${firefly.moveDelay}s`,
            '--drift-delay': `${firefly.driftDelay}s`,
            '--flash-delay': `${firefly.flashDelay}s`,
          }}
        ></div>
      ))}
    </>
  );
}
